import { useStoreActions } from '~/contexts';
import { useIntegrations } from '~/hooks/reactQuery/queries/useIntegrations';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { integrationModel, TimeActivitiesModel } from '~/models';
export const useQboTimeActivities = function useQboTimeActivities(relationshipId) {
    let { refreshOnHookMount = false, enabled = true } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { integrations } = useIntegrations({
        enabled: false
    });
    const allowTimeActivities = integrationModel.allowTimeActivities(integrations);
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.QboTimeActivities,
            relationshipId
        ],
        queryFn: ()=>allowTimeActivities ? api.qbo.getTimeActivities(relationshipId) : Promise.resolve(new TimeActivitiesModel()),
        enabled,
        refreshOnHookMount
    });
    return {
        data,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
